import {Article, Source} from "../repository/Article.repo";
import ViewBox from "./ViewBox";
import {environment} from "../environments/environment";
import {useCallback} from "react";

export function ArticleView(props: {article: Article | undefined, activeLanguage: string}){


    const mapHtmlWithSource = useCallback((htmlData: string, sources: Source[]) => {

        if(sources.length < 1){
            return htmlData;
        }

        const regex = /<sup>(.*?)<\/sup>/gi;

        let matchMap = htmlData.match(regex);

        if(matchMap === null){
            return htmlData;
        }

        matchMap = matchMap.map((match) => {
            return match.replace("<sup>", "").replace("</sup>", "");
        });


        matchMap.forEach((match) => {
            const sourceFinder = sources.find((source) => source.Number === Number(match));
            if(sourceFinder !== undefined){
                htmlData = htmlData.replace(`<sup>${match}</sup>`, `<sup><a target="_blank" href="${sourceFinder.Url}">${match}</a></sup>`)
            }
        })


        return htmlData;
    }, []);







    const getArticleName = useCallback(() => {

        if(props.activeLanguage === 'de'){
            return props.article?.Name
        }

        if(props.article?.ArticleLanguage.find((item:any) => item.lang === props.activeLanguage)){
            return props.article?.ArticleLanguage.find((item:any) => item.lang === props.activeLanguage).Name
        }

        return props.article?.Name

    }, [props]);


    const getArticleDescription = useCallback(() => {

        if(props.activeLanguage === 'de'){
            return props.article?.Description;
        }

        const find = props.article?.ArticleLanguage.find((item:any) => item.lang === props.activeLanguage);

        if(find){
            return find.Description
        }

        return props.article?.Description;


    }, [props.activeLanguage, props.article?.ArticleLanguage, props.article?.Description]);


    const getArticleSources = useCallback(() => {

        if(props.activeLanguage === 'de'){
            return props.article?.ArticleSources;
        }

        const find = props.article?.ArticleSourceLanguage.filter((item:any) => item.lang === props.activeLanguage);

        if(find){
            return find;
        }

        return props.article?.ArticleSources;

    }, [props.activeLanguage, props.article?.ArticleSourceLanguage, props.article?.ArticleSources]);


    if(props.article === undefined){
        return <div></div>
    }
    return (
        <ViewBox width={90} title={getArticleName()}>
            <div  style={{color: "#000", textAlign: "left", height: '100%', cursor: "initial"}}>

                <div>
                    <ul style={{listStyle: "none"}}>
                        {props.article.ArticleImages.map((image) => (
                            <li style={{float: "left", width: 250, marginRight: 10}}><img width={'100%'} src={environment.backendUrl + image.Url} /></li>
                        ))}
                    </ul>
                    <div style={{clear: "both"}} />
                </div>


                <div  dangerouslySetInnerHTML={{__html: mapHtmlWithSource(getArticleDescription(), getArticleSources())}}></div>



                <div>
                    <ul style={{listStyle: "none"}}>
                        {getArticleSources().map((source:any) => {
                            return (
                                <li>{source.Number}: <a target={"_blank"} href={source.Url}>{source.Url}</a></li>
                            )
                        })}
                    </ul>
                </div>

            </div>
        </ViewBox>
    )


}
